import React from "react";
import { Popover } from "@mui/material";
import { media, zIndexes, styled } from "@iventis/styles";

export const POPOVER_MAX_HEIGHT_LARGE_SCREEN = "50vh";

export const PopOverByCords: React.FC<{ x: number; y: number; children?: React.ReactNode; onExit: () => void }> = ({ x = 0, y = 0, children, onExit }) => (
    <StyledPopover onClose={onExit} id="schedule-popover" open anchorReference="anchorPosition" anchorPosition={{ top: y, left: x }}>
        <StyledContent>{children}</StyledContent>
    </StyledPopover>
);

const StyledPopover = styled(Popover)`
    z-index: ${zIndexes.schedule.calendarPopover};
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    ${media.large} {
        background-color: rgba(0, 0, 0, 0);
    }
`;

const StyledContent = styled.div`
    width: 95vw;
    position: relative;
    max-height: 100%;
    ${media.large} {
        width: 450px;
        max-height: 50vh;
    }
    ${media.extraLarge} {
        width: 500px;
    }
`;
